import { load } from "@nextgisweb/jsrealm/i18n/catalog";
load("layer", {"":{"Spatial reference system":["Система координат"]}})